import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
// import "react-widgets/styles.css";
// import DatePicker from "react-widgets/DatePicker";
import { getListGrupoByIdEmpresaPlataforma } from "../api/api-grupo";
import { obtenerListaEmpresaPlataforma } from "../api/api-empresa-plataforma";
import spinner from "../assets/iconos/spinner4.svg";
import { obtenerListVehiculoCombo } from "../api/api-vehiculo";
import { getListSubGrupoCombo } from "../api/api-sub-grupo";
// import momentLocalizer from "react-widgets-moment";

// new momentLocalizer(moment);

export default function ModalClienteSecundario({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();

    const [listActivo, setListActivo] = useState([]);
    const [activoSelected, setActivoSelected] = useState(null);

    const [listEmpresaPlataforma, setListEmpresaPlataforma] = useState([]);

    const [empresaPlataformaOrigenSelected, setEmpresaPlataformaOrigenSelected] = useState(null);
    const [empresaPlataformaDestinoSelected, setEmpresaPlataformaDestinoSelected] = useState(null);

    const [listGrupo, setListGrupo] = useState([]);
    const [grupoSelected, setGrupoSelected] = useState(null);

    const [listSubGrupo, setListSubGrupo] = useState([]);
    const [subGrupoSelected, setSubGrupoSelected] = useState(null);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        iniciar();
    }, [formData]);

    const iniciar = async () => {
        try {
            // console.log('formData');
            // console.log(formData);            
            const empPlataforma = await obtenerListaEmpresaPlataforma({ habilitado: 1 }, true, t);
            setListEmpresaPlataforma(empPlataforma);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    useEffect(() => {
        onChangeEmpresaPlataformaOrigenSelected();
    }, [empresaPlataformaOrigenSelected]);

    const onChangeEmpresaPlataformaOrigenSelected = async () => {
        setListActivo([]);
        setActivoSelected(null);
        if (empresaPlataformaOrigenSelected !== null) {
            const vehiculos = await obtenerListVehiculoCombo({ idEmpresaPlataforma: empresaPlataformaOrigenSelected.value });
            setListActivo(vehiculos);
        }
    };

    useEffect(() => {
        onChangeEmpresaPlataformaDestinoSelected();
    }, [empresaPlataformaDestinoSelected]);

    const onChangeEmpresaPlataformaDestinoSelected = async () => {
        setListGrupo([]);
        setGrupoSelected(null);
        setListSubGrupo([]);
        setSubGrupoSelected(null);
        if (empresaPlataformaDestinoSelected !== null) {
            const listGrupos = await getListGrupoByIdEmpresaPlataforma({ idEmpresaPlataforma: empresaPlataformaDestinoSelected.value });
            setListGrupo(listGrupos);
        }
    }

    useEffect(() => {
        onChangeGrupoSelected();
    }, [grupoSelected]);

    const onChangeGrupoSelected = async () => {
        setListSubGrupo([]);
        setSubGrupoSelected(null);
        if (grupoSelected !== null) {
            const listSubGrupo = await getListSubGrupoCombo({ idGrupo: grupoSelected.value });
            setListSubGrupo(listSubGrupo);
        }
    };

    const validateForm = async () => {
        try {
            // console.log('validateForm');
            // console.log(formData);
            setLoading(true);
            // console.log("proveedorSelected", proveedorSelected);
            let message = "";
            if (empresaPlataformaOrigenSelected === null || empresaPlataformaOrigenSelected === undefined) {
                message = message + "Select Empresa Origen" + '\n';
            }
            if (empresaPlataformaDestinoSelected === null || empresaPlataformaDestinoSelected === undefined) {
                message = message + "Select Empresa Destino" + '\n';
            }
            if (grupoSelected === null || grupoSelected === undefined) {
                message = message + "Group not found" + '\n';
            }
            if (subGrupoSelected === null || subGrupoSelected === undefined) {
                message = message + "SubGroup not found" + '\n';
            }
            if (activoSelected === null || activoSelected === undefined) {
                message = message + t("alert_must_select_unit") + '\n';
            }

            if (message.length > 0) {
                alert(message);
                setLoading(false);
                return;
            }
            formData.idGrupo = grupoSelected.value;
            formData.idSubGrupo = subGrupoSelected.value;
            formData.idActivo = activoSelected.label;
            formData.idEmpresaPlataformaOrigen = empresaPlataformaOrigenSelected.value;
            formData.idEmpresaPlataformaDestino = empresaPlataformaDestinoSelected.value;
            console.log('formData', formData);
            onConfirm(formData);
            setLoading(false);

        } catch (err) {
            console.log('validateForm err');
            console.log(err);
            setLoading(false);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            id: 0,
            idActivo: null,
            idEquipo: null,
            idSim: null,
            fechaInstalacion: "",
            numeroOrdenInstalacion: "",
        });
        setActivoSelected(null);
        onCancel();
        setEmpresaPlataformaOrigenSelected(null);
        setEmpresaPlataformaDestinoSelected(null);
        setGrupoSelected(null);
        setSubGrupoSelected(null);
    };

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-2/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
                                <label className="font-bold">{t("label_from")}</label>
                                <div className="mb-4">
                                    <label className="block text-gray-600 font-semibold mb-1">{t("label_company")}<span className="text-red-500">*</span></label>
                                    <Select
                                        options={listEmpresaPlataforma}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={empresaPlataformaOrigenSelected}
                                        onChange={(event) => { setEmpresaPlataformaOrigenSelected(event); }}
                                        placeholder={t("label_select_company")}
                                        className="w-full"
                                        menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-600 font-semibold mb-1">{t("label_select_activo")}<span className="text-red-500">*</span></label>
                                    <Select
                                        options={listActivo}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={activoSelected}
                                        onChange={(event) => setActivoSelected(event)}
                                        placeholder={t("label_select_activo")}
                                        className="w-full"
                                        menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                    />
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
                                <label className="font-bold">{t("label_to")}</label>
                                <div className="mb-4">
                                    <label className="block text-gray-600 font-semibold mb-1">{t("label_company")}<span className="text-red-500">*</span></label>
                                    <Select
                                        options={listEmpresaPlataforma}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={empresaPlataformaDestinoSelected}
                                        onChange={(event) => { setEmpresaPlataformaDestinoSelected(event); }}
                                        placeholder={t("label_select_company")}
                                        className="w-full"
                                        menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-600 font-semibold mb-1">{t("label_group")}<span className="text-red-500">*</span></label>
                                    <Select
                                        options={listGrupo}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={grupoSelected}
                                        onChange={(event) => { setGrupoSelected(event); }}
                                        placeholder={t("label_select_group")}
                                        className="w-full"
                                        menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-gray-600 font-semibold mb-1">{t("label_sub_group")}<span className="text-red-500">*</span></label>
                                    <Select
                                        options={listSubGrupo}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={subGrupoSelected}
                                        onChange={(event) => { setSubGrupoSelected(event); }}
                                        placeholder={t("label_select_sub_group")}
                                        className="w-full"
                                        menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                                    />
                                </div>
                            </div>
                        </div>


                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            {loading === false && (
                                <button
                                    onClick={validateForm}
                                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                                >
                                    Acceptar
                                </button>
                            )}
                            {loading === true && (
                                <button className="login_button flex justify-center">
                                    <img className="spinner"
                                        alt="spinner" src={spinner} />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
